<div class="container-fluid py-3">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h5 class="mb-0">Production Data — Client Setup</h5>
    <div class="d-flex gap-2 align-items-center">
      <span *ngIf="varianceQueued" class="text-success small">Variance report queued.</span>
      <button class="btn btn-sm btn-outline-secondary"
              (click)="queueVariance()"
              [disabled]="varianceQueuing || varianceQueued">
        {{ varianceQueuing ? 'Queuing…' : 'Run Variance' }}
      </button>
      <ng-container *ngIf="hasDirty">
        <button class="btn btn-sm btn-secondary" (click)="discardChanges()" [disabled]="saving">Discard</button>
        <button class="btn btn-sm btn-primary" (click)="saveAll()" [disabled]="saving">
          {{ saving ? 'Saving…' : 'Save Changes (' + dirtyIds.size + ')' }}
        </button>
      </ng-container>
    </div>
  </div>

  <div class="mb-2" style="max-width:320px;">
    <input class="form-control form-control-sm" type="search"
           [(ngModel)]="searchTerm"
           placeholder="Search clients, account ID…" />
  </div>

  <div *ngIf="loading" class="text-muted">Loading...</div>

  <table *ngIf="!loading" class="table table-sm table-hover table-striped align-middle">
    <thead class="table-light">
      <tr>
        <th>Client</th>
        <th>Enabled</th>
        <th>ORMS User ID</th>
        <th>ORMS Market ID</th>
        <th>Billing Freq.</th>
        <th>MSA Signed</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let c of filteredClients" [class.table-warning]="dirtyIds.has(c.clientId)">
        <td>{{ c.displayName }}</td>
        <td>
          <div class="form-check form-switch mb-0">
            <input class="form-check-input" type="checkbox"
                   [checked]="c.isEnabled"
                   (change)="toggleEnabled(c)" />
          </div>
        </td>
        <td>
          <input *ngIf="c.isEnabled" class="form-control form-control-sm"
                 [(ngModel)]="c.accountId"
                 (ngModelChange)="markDirty(c)"
                 placeholder="—" />
          <span *ngIf="!c.isEnabled" class="text-muted">—</span>
        </td>
        <td>
          <input *ngIf="c.isEnabled" class="form-control form-control-sm" type="number"
                 [(ngModel)]="c.extClientId"
                 (ngModelChange)="markDirty(c)"
                 placeholder="—" style="width:100px" />
          <span *ngIf="!c.isEnabled" class="text-muted">—</span>
        </td>
        <td>
          <select *ngIf="c.isEnabled" class="form-select form-select-sm"
                  [(ngModel)]="c.billingFrequency"
                  (ngModelChange)="markDirty(c)" style="width:130px">
            <option [ngValue]="null">— None —</option>
            <option *ngFor="let opt of billingOptions" [value]="opt">{{ opt }}</option>
          </select>
          <span *ngIf="!c.isEnabled" class="text-muted">—</span>
        </td>
        <td>
          <div *ngIf="c.isEnabled" class="form-check form-switch mb-0">
            <input class="form-check-input" type="checkbox"
                   [(ngModel)]="c.msaSigned"
                   (ngModelChange)="markDirty(c)" />
          </div>
          <span *ngIf="!c.isEnabled" class="text-muted">—</span>
        </td>
        <td>
          <button *ngIf="c.isEnabled" class="btn btn-sm btn-outline-primary"
                  (click)="openDetail(c)">
            Details
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
